import { DG } from '../dg';

export const ORG_TAG = '@org';

export const GLOBAL_TAG = '@global';

export const REPL_TAG = '@repl';

export const relTag = (ident: DG.Graph.Identity): string =>
  `@rel-${ident.toString()}`;

export const colTag = (ident: DG.Graph.Identity): string =>
  `@col-${ident.toString()}`;

export const userTag = (userId: string): string => `@user-${userId}`;

export const INTERACTIVE_TAG = '@interactive';
